window.addEventListener("scroll", function () {
  const header = document.querySelector(".header");
  if (!header) return;

  if (window.scrollY > 100) {
    header.classList.add("scroll");
  } else {
    header.classList.remove("scroll");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const readMoreBtns = document.querySelectorAll(".read-more-btn");

  readMoreBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      const parent = this.closest(".text-format");

      const moreText = parent?.querySelector(".more-text");
      if (!moreText) return;

      moreText.classList.remove("hidden");

      this.classList.add("hidden");
    });
  });
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.btn.btn-primary:not(.toggle-variants)');
  const socialLink = e.target.closest('.main_center-menu .social-link');
  const cartLink = e.target.closest('.cart__link');
  const accountLink = e.target.closest('.account__link');
  const secondLevelLink = e.target.closest('.second-level a');
  const dropdownLink = e.target.closest('.main_center-menu .dropdown .content li a');
  const depthLink = e.target.closest('.sliding-menu .depth-sub-menu-children li a');
  const blogLink = e.target.closest('.blog-link');
  const viewAllLink = e.target.closest('.view-all-link');

  if (btn && !btn.closest('.svc-card')) {
    btn.classList.add('loading-btn');

    setTimeout(() => {
      btn.classList.remove('loading-btn');
    }, 1000);
  }

  if (viewAllLink) {
    viewAllLink.classList.add('loading-link');
    setTimeout(() => {
      viewAllLink.classList.remove('loading-link');
    }, 1000);
  }

  if (socialLink) {
    socialLink.classList.add('loading-link');
    if (!socialLink.querySelector('.loader-spinner')) {
      const spinner = document.createElement('span');
      spinner.className = 'loader-spinner';
      socialLink.appendChild(spinner);

      setTimeout(() => {
        spinner.remove();
        socialLink.classList.remove('loading-link');
      }, 1000);
    }
  }

  if (cartLink) {
    cartLink.classList.add('loading-link');
    setTimeout(() => {
      cartLink.classList.remove('loading-link');
    }, 1000);
  }

  if (accountLink) {
    accountLink.classList.add('loading-link');
    setTimeout(() => {
      accountLink.classList.remove('loading-link');
    }, 1000);
  }

  if (secondLevelLink) {
    secondLevelLink.classList.add('loading-link');
    setTimeout(() => {
      secondLevelLink.classList.remove('loading-link');
    }, 1000);
  }

  if (dropdownLink) {
    dropdownLink.classList.add('loading-link');
    setTimeout(() => {
      dropdownLink.classList.remove('loading-link');
    }, 1000);
  }

  if (depthLink) {
    depthLink.classList.add('loading-link');
    setTimeout(() => {
      depthLink.classList.remove('loading-link');
    }, 1000);
  }

  if (blogLink) {
    blogLink.classList.add('loading-link');
    setTimeout(() => {
      blogLink.classList.remove('loading-link');
    }, 1000);
  }

});


document.querySelectorAll('.category-list .item').forEach(el => {
  el.addEventListener('click', () => {
    el.classList.add('loading-item');
    setTimeout(() => {
      el.classList.remove('loading-item');
    }, 1000);
  });
});

document.querySelectorAll('.item-header--title').forEach(el => {
  el.addEventListener('click', () => {
    el.classList.add('loading-item');
    setTimeout(() => {
      el.classList.remove('loading-item');
    }, 1000);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const offset = 200;

  document.querySelectorAll('a.collection-tag.animate-item[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const targetId = link.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});
